export enum ingredientCategory {
  'bun' = 'bun',
  'sauce' = 'sauce',
  'main' = 'main'
}
